import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IHoldGroup } from 'src/app/_models/compliance';
import { HoldsService } from 'src/app/_services/holds.services';

export interface IHoldDialogData {
  title: string;
  name: string;
  description: string;
  button: string
}

@Component({
  selector: 'app-holds',
  templateUrl: './holds.component.html',
  styleUrls: ['./holds.component.scss']
})
export class HoldsComponent implements OnInit {
  tableData: MatTableDataSource<IHoldGroup>
  allHoldGroups: any
  displayedColumns = ["name", "description", "created_by", "modified_by", "active"];
  openHoldForm: boolean = false
  createdHold: boolean = false
  holdName: string
  noHolds: boolean = false
  holdsCount: number = 0

  constructor(
    private holdsService: HoldsService,
    public dialog: MatDialog
  ) { }

  dialogData: IHoldDialogData

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.tableData.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.tableData.paginator = this.paginator;
    }
  }

  ngOnInit() {
    this.holdsService.getHoldGroups().subscribe(holds => {
      if (holds == "no hold groups to display") {
        this.allHoldGroups = null
        this.noHolds = true
      } else {
        this.allHoldGroups = holds
        this.tableData = new MatTableDataSource(holds)
        this.tableData.sort = this.sort
        this.tableData.paginator = this.paginator
        this.holdsCount = (this.allHoldGroups.length)
        this.noHolds = false
      }
    })
  }

  refreshPage() {
    this.ngOnInit();
  }

  back() {
    this.openHoldForm = false
    this.createdHold = false
    this.refreshPage()
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableData.filter = filterValue.trim().toLowerCase();

    if (this.tableData.paginator) {
      this.tableData.paginator.firstPage();
      this.holdsCount = this.tableData.filteredData.length
    }
  }

  createHold(event) {
    this.openHoldForm = true
    this.dialogData = {
      title: "Create Hold Group",
      name: "",
      description: "",
      button: "Create"
    };
  }

  createHoldButton() {
    this.holdsService.createHold(this.dialogData).subscribe(data => {
      //alert("Updated Policy- " + this.dialogData.name + " successfully!")
      this.ngOnInit()
      this.createdHold = true
    })
  }

  deleteHold(event, holdId) {
    console.log("DELETE", holdId)
  }

  updateHold(event, hold) {
    this.openHoldForm = true
    this.dialogData = {
      title: "Update Group",
      name: hold.name,
      description: hold.description,
      button: "Update"
    };
  }

  updateHoldButton() {
    console.log("UPDATE HOLD", this.dialogData)
  }
}